import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ResourceLoading } from "../../../../components/utils/ResourceLoading";

/**
 * Version history lives on the document view. Keep this route so old links work.
 */
export const HseKsDocumentVersions = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (!id) return;
    navigate(`/dashboard/hse-ks/documents/${id}#document-revisions`, { replace: true });
  }, [id, navigate]);

  return <ResourceLoading size="base" />;
};
